module.exports = __webpack_public_path__ + "src/app/_content/BMWFonts/BMWTypeNextPro-Thin.woff?b865f93cdf1937e95179da03d7621bab";